import React from 'react';
import { StreamEventType } from '../types';
import './StreamingStatus.css';

interface StreamingStatusProps {
  currentStep: string;
  isStreaming: boolean;
  streamedContent: string;
  completionSummary?: string;
}

export default function StreamingStatus({ currentStep, isStreaming, streamedContent, completionSummary }: StreamingStatusProps) {
  const hasContent = currentStep || completionSummary;
  
  if (!isStreaming && !hasContent) {
    return null;
  }

  return (
    <div className="streaming-status-content">
      {currentStep && (
        <div className="status-step">
          <div className="status-spinner"></div>
          <span className="status-text">{currentStep}</span>
        </div>
      )}
      {completionSummary && (
        <div className="status-step completion-step">
          <span className="check-icon">✓</span>
          <span className="status-text">{completionSummary}</span>
        </div>
      )}
      {!currentStep && !completionSummary && isStreaming && (
        <div className="status-step">
          <div className="status-spinner"></div>
          <span className="status-text">Processing your request...</span>
        </div>
      )}
    </div>
  );
}

export function getStatusMessage(eventType: StreamEventType, toolName?: string, nodeName?: string): string {
  switch (eventType) {
    case StreamEventType.NODE_START:
      if (nodeName?.toLowerCase().includes('intent')) {
        return 'Analyzing and classifying your query...';
      } else if (nodeName?.toLowerCase().includes('response')) {
        return 'Generating your personalized answer...';
      } else if (nodeName?.toLowerCase().includes('extraction')) {
        return 'Extracting key details from your request...';
      } else if (nodeName?.toLowerCase().includes('routing')) {
        return 'Planning optimal route...';
      } else if (nodeName?.toLowerCase().includes('station')) {
        return 'Extracting best charging stations...';
      }
      return 'Processing your request...';
    
    case StreamEventType.TOOL_START:
      const lowerToolName = toolName?.toLowerCase() || '';
      
      if (lowerToolName.includes('route') && lowerToolName.includes('station')) {
        return 'Finding shortest route and retrieving charging stations...';
      } else if (lowerToolName.includes('route')) {
        return 'Calculating optimal route for your trip...';
      } else if (lowerToolName.includes('metadata') || lowerToolName.includes('retrieve_charging_station_metadata')) {
        return 'Fetching detailed station information...';
      } else if (lowerToolName.includes('charging_station') || lowerToolName.includes('station')) {
        return 'Searching for available charging stations...';
      } else if (lowerToolName.includes('geocode') || lowerToolName.includes('location')) {
        return 'Resolving location coordinates...';
      } else if (lowerToolName.includes('calculate') || lowerToolName.includes('distance')) {
        return 'Calculating route distances and timing...';
      } else if (lowerToolName.includes('filter')) {
        return 'Filtering stations based on your preferences...';
      }
      return 'Retrieving information...';
    
    case StreamEventType.TOOL_COMPLETE:
      return '';
    
    case StreamEventType.NODE_COMPLETE:
      return '';
    
    default:
      return '';
  }
}

export function getCompletionSummary(summary?: string, success?: boolean): string {
  if (!summary) return '';
  
  if (success === false) {
    return `Issue: ${summary}`;
  }
  
  return summary;
}
